<template>
  <div class="admin_main_page">
    <mod-header></mod-header>
    <div class="wrapper">
      <mod-sidebar></mod-sidebar>
      <div class="main-page">
        <keep-alive>
          <router-view v-if='$route.meta.keepAlive'></router-view>
        </keep-alive>
        <router-view v-if='!$route.meta.keepAlive'></router-view>
      </div>
      <right-nav></right-nav>
    </div>
  </div>
</template>

<script>
import modHeader from './area/header';
import modSidebar from './area/sidebar';
import rightNav from './area/rightNav';
export default {
  components: {
    modHeader,
    modSidebar,
    rightNav
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/index.vue